<script>
	import { slide } from 'svelte/transition'
	let resetNum

	$: if (resetNum < 0) {
		resetNum = 0
	}

	function numberWithCommas(x) {
		return x
			.toFixed(2)
			.toString()
			.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	}

	$: monthlyCost = `$${numberWithCommas(resetNum * 17.88)}`
	$: yearlyCost = `$${numberWithCommas(resetNum * 17.88 * 12)}`
</script>

<style>
	.wrap {
		margin: 0 0 25px;
	}
	.lower-wrap {
		margin: -15px;
		padding: 15px;
	}
	h5 {
		margin: 0 0 15px !important;
	}
	input {
		border-radius: 3px;
		padding: 9px 15px;
		font-size: 1.1em;
		border: 1px solid #ccc;
	}
	.jobs-grid h5 {
		font-weight: 800;
	}
	.jobs-grid p {
		font-size: 2.2em;
		line-height: 1.2;
		margin: 0 0 12px;
		color: #2954b7;
	}
	.jobs-grid .grid-item {
		padding: 1.6rem 4%;
	}
</style>

<div class="wrap">
	<h3>Number of resets per month</h3>
	<label for="reset" class="sr-only">Number of resets</label>
	<input id="reset" type="number" bind:value={resetNum} />

	{#if resetNum}
		<div class="lower-wrap" transition:slide={{ duration: 600 }}>
			<h3>Estimated cost to your company without ReACT:</h3>
			<div class="grid-two jobs-grid">
				<div class="grid-item ">
					<h5>Monthly Cost*</h5>
					<p>{monthlyCost}</p>
					<small>
						*According to Gartner's Market Guide for Password Management Tools
					</small>
				</div>
				<div class="grid-item ">
					<h5>Yearly Cost</h5>
					<p>{yearlyCost}</p>
				</div>
			</div>
		</div>
	{/if}
</div>
